import { render } from "./TouchMePageTest.vue?vue&type=template&id=58012c7b&scoped=true"
import script from "./TouchMePageTest.vue?vue&type=script&lang=js"
export * from "./TouchMePageTest.vue?vue&type=script&lang=js"

import "./TouchMePageTest.vue?vue&type=style&index=0&id=58012c7b&scoped=true&lang=css"

import exportComponent from "../../../../biotron-complaint-20260813/WebMidiVue-integrated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58012c7b"]])

export default __exports__